document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".ua-hero").forEach((slider) => {

        const slides = slider.querySelectorAll(".ua-slide");
        const dots = slider.querySelectorAll(".ua-dot");

        const prev = slider.querySelector(".ua-prev");
        const next = slider.querySelector(".ua-next");

        const autoplay =
            slider.dataset.autoplay === "true";

        const speed =
            parseInt(slider.dataset.speed || 5) * 1000;

        let current = 0;
        let timer = null;
        let touchStart = 0;
        let touchEnd = 0;

        function showSlide(index){

            if(index < 0)
                index = slides.length - 1;

            if(index >= slides.length)
                index = 0;

            slides.forEach((slide,i)=>{

                slide.classList.toggle("active",i===index);

            });

            dots.forEach((dot,i)=>{

                dot.classList.toggle("active",i===index);

            });

            current = index;

        }

        function nextSlide(){

            showSlide(current+1);

        }

        function prevSlide(){

            showSlide(current-1);

        }

        function startAutoplay(){

            if(!autoplay) return;

            stopAutoplay();

            timer = setInterval(nextSlide,speed);

        }

        function stopAutoplay(){

            if(timer){

                clearInterval(timer);

            }

        }

        next?.addEventListener("click",()=>{

            nextSlide();

            startAutoplay();

        });

        prev?.addEventListener("click",()=>{

            prevSlide();

            startAutoplay();

        });

        dots.forEach((dot,index)=>{

            dot.addEventListener("click",()=>{

                showSlide(index);

                startAutoplay();

            });

        });

        slider.addEventListener("mouseenter",stopAutoplay);

        slider.addEventListener("mouseleave",startAutoplay);

        slider.addEventListener("touchstart",(e)=>{

            touchStart = e.changedTouches[0].clientX;

        });

        slider.addEventListener("touchend",(e)=>{

            touchEnd = e.changedTouches[0].clientX;

            if(touchStart-touchEnd>60){

                nextSlide();

            }

            if(touchEnd-touchStart>60){

                prevSlide();

            }

            startAutoplay();

        });

        document.addEventListener("visibilitychange",()=>{

            if(document.hidden){

                stopAutoplay();

            }else{

                startAutoplay();

            }

        });

        showSlide(0);

        startAutoplay();

    });

});